import { useDeleteDemoMutation } from '@carboncopyco/data';
import { DeleteOutlineIcon } from '@carboncopyco/icons';
import type { Folder } from '@carboncopyco/types';
import { ConfirmAlert, notify } from '@carboncopyco/ui';
import { useDemoAnalytics } from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';

interface ArchiveDemoModalProps {
  organizationId: string;
  demoId: string;
  onClose: () => void;
  show: boolean;
  navigateOnSuccess?: () => void;
  folderId?: Folder['id'];
}

export const ArchiveDemoModal = ({
  organizationId,
  demoId,
  show,
  onClose,
  navigateOnSuccess,
  folderId,
}: ArchiveDemoModalProps) => {
  const [archiveDemo, { isLoading }] = useDeleteDemoMutation();
  const [isDisabled, setIsDisabled] = useBoolean();
  const { trackDemoClickArchiveApprove, trackDemoClickArchiveCancel } =
    useDemoAnalytics('demo_info_page_archive_demo_modal');

  return (
    <ConfirmAlert
      disabled={isDisabled}
      loading={isLoading}
      title="Archive demo"
      description="This demo will no longer be accessible unless it’s restored."
      show={show}
      onConfirm={() => {
        setIsDisabled.setTrue();
        trackDemoClickArchiveApprove({ demoId });
        archiveDemo({
          id: demoId,
          organizationId,
          folderId,
        })
          .unwrap()
          .then(() => {
            navigateOnSuccess?.();
            notify.success('Archived demo successfully');
          })
          .catch((error) => {
            const errorMessage = error?.data?.message;
            if (errorMessage.includes('Playbook')) {
              notify.error(error.data.message);
              return;
            }
            notify.error('Error archiving clone');
          })
          .finally(() => {
            setIsDisabled.setFalse();
            onClose();
          });
      }}
      onClose={() => {
        trackDemoClickArchiveCancel({ demoId });
        onClose();
      }}
      danger
      containerClass="w-ds-normal-modal"
      yesIcon={<DeleteOutlineIcon />}
      yesLabel="Archive"
    />
  );
};
